import card1 from '../assets/images/card1.png';
import card2 from '../assets/images/card2.png';
import card3 from '../assets/images/card3.png';
import card4 from '../assets/images/card4.png';

const tippsData = [
  {
    image: card1,
    title: 'Gebrauchtwagen kaufen – worauf Sie achten sollten, um keine böse Überraschung zu erleben',
    answer: 'Achten Sie auf Inspektionsnachweise, nachvollziehbare Fahrzeughistorie und lassen Sie das Auto nach Möglichkeit von einem unabhängigen Sachverständigen vor dem Kauf prüfen.'
  },
  {
    image: card2,
    title: 'Fahrzeugpapiere prüfen – das müssen Sie vor dem Kauf wissen',
    answer: 'Überprüfen Sie Fahrzeugschein und Fahrzeugbrief sorgfältig – besonders auf Übereinstimmung der FIN und Vorbesitzer.'
  },
  {
    image: card3,
    title: 'Tacho-Manipulation erkennen – so schützen Sie sich vor Betrug',
    answer: 'Achten Sie auf Abnutzung von Lenkrad, Pedalen und Sitzen – sie müssen zum Kilometerstand passen.'
  },
  {
    image: card4,
    title: 'Privater Autokauf – Schritt für Schritt erklärt',
    answer: 'Machen Sie einen schriftlichen Kaufvertrag, prüfen Sie das Auto genau und bezahlen Sie sicher, z.B. per Echtzeitüberweisung.'
  }
];
export default tippsData;